
import { defineComponent, PropType, ref } from 'vue'
import { dateToString, formatDate } from '@/services/date'
import JrInputView from '@/components/jr-parts/JrInputView.vue'
import TextOmit from '@/components/displays/TextOmit.vue'
import { ElInput } from 'element-plus'

/**
 * 日付複数選択コンポーネント
 * 表示時はカンマ区切りで表示する
 */
export default defineComponent({
  name: 'JrDateRangePicker',
  emits: ['update:modelValue'],
  components: {
    JrInputView,
    TextOmit,
  },
  props: {
    modelValue: {
      // 文字列の日付配列
      type: Array as PropType<string[]>,
      required: false,
      default: null,
    },
    format: {
      type: String,
      required: false,
      default: 'YYYY年MM月DD日',
    },
    disabledDate: {
      type: Function,
      required: false,
      default: null,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    size: {
      type: String,
      required: false,
      default: 'medium',
    },
    isEdit: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  setup(props, context) {
    // 本来はtypeof ElDatePickerだが、何故か型定義にfocusが無いためElInputで代用
    const pickerRef = ref<InstanceType<typeof ElInput>>()
    return {
      pickerRef,
      formatDate,
      update: (dates: Array<Date> | null | string) => {
        if (dates == null || !Array.isArray(dates)) {
          context.emit('update:modelValue', [])
          return
        }
        // 昇順で並び替え
        dates.sort((before, after) => before.getTime() - after.getTime())
        const strDates = dates.map((date) => {
          return dateToString(date)
        })
        context.emit('update:modelValue', strDates)
      },
      focus: () => {
        if (pickerRef.value) {
          pickerRef.value.focus()
        }
      },
    }
  },
})
